<template>
  <a class="jm-text-primary jm-font-bold"><slot></slot></a>
</template>

<script>
export default {
  name: 'TextLink'
}
</script>

<style lang="scss" scoped>
a {
  text-decoration: underline;
}
</style>
